var alignment_rtlignore_default = {
  "alignLeft": "Z80Uz",
  "textWrapNowrap": "FQWCl",
  "alignRight": "dCt6x",
  "alignCenter": "_8FoDf",
  "sizeFullWidth": "MWNpQ",
  "renderedInTable": "_25Smd",
  "sizeOriginal": "Sr5o4",
  "sizeContent": "EJMb7",
  "sizeSmall": "ywscQ",
  "sizeSmallCenter": "SKYhj",
  "flex": "_4-uyp",
  "LEFT": "mQspv",
  "CENTER": "-XYEb",
  "RIGHT": "azBAB",
  "AUTO": "WmV-K",
  "JUSTIFY": "Pohl9"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore.scss.js.map
